import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MuiAppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Container from '@material-ui/core/Container'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: theme.mixins.toolbar.minHeight
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))

export interface AppBarProps {
  children: ReactElement | ReactElement[]
}

function AppBar({ children }: AppBarProps): ReactElement {
  const classes = useStyles()
  return (
    <div data-testid="app-bar" className={classes.root}>
      <MuiAppBar position="fixed" elevation={2}>
        <Toolbar disableGutters={true} variant="dense">
          <Container maxWidth="md" className={classes.container}>
            {children}
          </Container>
        </Toolbar>
      </MuiAppBar>
    </div>
  )
}

export default AppBar
